import { motion } from 'framer-motion';
import { HelpCircle, TrendingDown, Frown } from 'lucide-react';

export default function Problem() {
    const problems = [
        {
            icon: HelpCircle,
            title: 'What should I post?',
            description: 'Staring at a blank camera with no ideas',
        },
        {
            icon: TrendingDown,
            title: 'Will anyone watch?',
            description: 'Fear of low engagement and being ignored',
        },
        {
            icon: Frown,
            title: 'How do I go viral?',
            description: 'Uncertainty about trends and what works',
        },
    ];

    return (
        <section className="py-20 gradient-bg">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-16"
                >
                    <h2 className="font-display text-4xl sm:text-5xl font-bold text-white mb-4">
                        Tired of Staring at a Blank Screen?
                    </h2>
                    <p className="text-xl text-gray-400 max-w-3xl mx-auto">
                        Creating content shouldn't feel like work. We get it.
                    </p>
                </motion.div>

                <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
                    {problems.map((problem, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: index * 0.1 }}
                            className="bg-dark-800 border border-dark-700 rounded-2xl p-8 text-center hover:shadow-lg hover:shadow-primary-500/10 transition-all duration-300"
                        >
                            <div className="inline-flex items-center justify-center w-16 h-16 bg-red-500/20 border border-red-500/50 rounded-full mb-6">
                                <problem.icon className="w-8 h-8 text-red-400" />
                            </div>
                            <h3 className="font-display text-xl font-bold text-white mb-3">{problem.title}</h3>
                            <p className="text-gray-400">{problem.description}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
